import { useCallback, useEffect, useState } from "react";

export const useDisclose = (props) => {

    const { isOpen:_isOpen = false} = props ?? {};

    const [isOpen, setIsOpen] = useState(_isOpen);

    const onOpen = useCallback(() => setIsOpen(true), []);
    const onClose = useCallback(() => setIsOpen(false), []);
    const onToggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);
    const setState = useCallback((state) => setIsOpen(state), []);

    useEffect(() => {
        return () => setIsOpen(false);
    }, [])

    return {
        isOpen,
        onOpen,
        onClose,
        onToggle,
        setState
    };

};